import Service from '../Service'
import {uniqWith, isEqual, orderBy} from 'lodash'

const endPoint = '/shipping/service/v1/rates'
class DeliveryMethodService extends Service {
  constructor() {
    super(endPoint)
  }
  async list(params: any) {
    const data = await this.post(params)
    return mapToFetchRates(data)
  }

  async list2(id: any) {
    const data = await this.get(`/draft/order/${id}`)
    return mapToFetchRates(data)
  }

  async getEditOrderRates(id: string, addressChanged: boolean) {
    const data = await this.get(`/order/edit/${id}?addressChanged=${addressChanged}`)
    return mapToFetchRates(data)
  }

  async fetchRates(params: any) {
    const availableOn = 'admin_portal'
    const data = await this.post(params, `/${availableOn}`)
    return mapToFetchRates(data)
  }
}

const deliveryMethodService = new DeliveryMethodService()
export default deliveryMethodService

const mapToFetchRates = (data: any) => {
  let list: any = []
  data &&
    data.forEach(({carrierType, rates}: any) => {
      const price = rates.map((rate: any) => ({
        ...rate,
        carrierType,
      }))
      list = list.concat(price)
    })
  const checkUnique = uniqWith(list, isEqual)
  return orderBy(checkUnique, 'rate', 'asc')
}
